module.exports = __webpack_public_path__ + "img/Statistics.45e3f7b0.png";